import React from "react";
import { css } from "@emotion/react";
import { FONTS } from "../../styles/fonts";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { CSS_MQ } from "../../styles/breakpoints";

export const listStyles = css`
  display: grid;
  grid-template-rows: auto;

  gap: var(--plp-grid-gap);
  grid-template-columns: repeat(2, minmax(0, 1fr));
  ${CSS_MQ.atLeastMd} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  ${CSS_MQ.atLeastLg} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export const subHeadlineStyles = css`
  ${FONTS.SwarovskiFutura300};

  margin: 5px 0;

  font-size: 16px;
  color: var(--secondary-text-color);
  letter-spacing: 1px;

  &:not(:last-of-type) {
    &:after {
      content: ", ";
    }
  }
`;

export const headlineStyles = css`
  ${FONTS.SwarovskiFutura300};

  color: ${CSS_COLORS.Green};
  line-height: 1.1;

  font-size: 30px;
  letter-spacing: 1px;
  ${CSS_MQ.atLeastLg} {
    font-size: 48px;
    letter-spacing: 2px;
  }
`;
